export const businessData = {
    navTitle: "Navigate Hub",
    noDropDowns: [
        {
            title: "Customer Stories",
            url_slug: "case-studies-business"
        }
    ],
    sections: [
        {
            title: "Business Need",
            sublevels: [
                {
                    url_slug: "case-for-language-learning",
                    title: "The Case for Language Learning"
                },
                {
                    url_slug: "customer-service",
                    title: "Customer Service"
                },
                {
                    url_slug: "workforce-development",
                    title: "Workforce Development"
                },
                {
                    url_slug: "productivity-collaboration",
                    title: "Productivity & Collaboration"
                },
                {
                    url_slug: "workplace-safety",
                    title: "Workplace Safety"
                },
                {
                    url_slug: "diversity-inclusion",
                    title: "Diversity & Inclusion"
                },
                {
                    url_slug: "english-language-learning-2",
                    title: "English Language Learning"
                },
                {
                    url_slug: "market-expansion",
                    title: "Market Expansion"
                }
            ]
        },
        {
            title: "Resource Type",
            sublevels: [
                {
                    url_slug: "bus-infographics",
                    title: "Infographics"
                },
                {
                    url_slug: "white-papers-business",
                    title: "Reports"
                },
                {
                    url_slug: "ebooks-corporate",
                    title: "eBooks"
                },
                {
                    url_slug: "videos",
                    title: "Videos"
                },
                {
                    url_slug: "webinars",
                    title: "Webinars"
                },
                {
                    url_slug: "factsheet-business",
                    title: "Fact Sheets"
                }
            ]
        }
    ]
};

export const k12Data = {
    navTitle: "Navigate Hub",
    noDropDowns: [
        {
            title: "Customer Stories",
            url_slug: "customer-success-stories"
        }
    ],
    sections: [
        {
            title: "Need",
            sublevels: [
                {
                    url_slug: "world-language",
                    title: "World Language"
                },
                {
                    url_slug: "english-language-learning",
                    title: "English Language"
                },
                {
                    url_slug: "adult-education",
                    title: "Adult Education"
                }
            ]
        },
        {
            title: "Implementation",
            sublevels: [
                {
                    url_slug: "blended-learning",
                    title: "Blended Learning"
                },
                {
                    url_slug: "online-learning",
                    title: "Online Learning"
                }
            ]
        },
        {
            title: "Type",
            sublevels: [
                {
                    url_slug: "infographics",
                    title: "Infographics"
                },
                {
                    url_slug: "white-papers",
                    title: "Reports"
                },
                {
                    url_slug: "ebooks",
                    title: "eBooks"
                },
                {
                    url_slug: "video",
                    title: "Videos"
                },
                {
                    url_slug: "k12-webinars",
                    title: "Webinars"
                },
                {
                    url_slug: "podcasts",
                    title: "Podcasts"
                },
                {
                    url_slug: "brochures",
                    title: "Brochures"
                },
                {
                    url_slug: "teacher-resources",
                    title: "Teacher Resources"
                }
            ]
        }
    ]
};

export const serviceData = {
    navTitle: "Navigate Hub",
    sections: [
        {
            title: "Foundations",
            sublevels: [
                {
                    title: "for Education"
                },
                {
                    url_slug: "getting-started-foundations-k12",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-k12-found",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-k12-found",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-k12-found",
                    title: "Learner Resources"
                },
                {
                    title: "for Enterprise"
                },
                {
                    url_slug: "getting-started-ent-found",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-ent-found",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-ent-found",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-enterprise-foundations",
                    title: "Learner Resources"
                }
            ]
        },
        {
            title: "Advantage",
            sublevels: [
                {
                    title: "for Education"
                },
                {
                    url_slug: "getting-started-adv-edu",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-adv-edu",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-adv-edu",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-adv-edu",
                    title: "Learner Resources"
                },
                {
                    title: "for Enterprise"
                },
                {
                    url_slug: "getting-started-rsa-ent",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-rsa-ent",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-rsa-ent",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-rsa-ent",
                    title: "Learner Resources"
                }
            ]
        },
        {
            title: "Advanced",
            sublevels: [
                {
                    url_slug: "getting-started-aeb",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-aeb",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-aeb",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-aeb",
                    title: "Learner Resources"
                }
            ]
        },
        {
            title: "Catalyst",
            sublevels: [
                {
                    url_slug: "getting-started-catalyst",
                    title: "Getting Started"
                },
                {
                    url_slug: "administrator-tools-catalyst",
                    title: "Administrator Tools"
                },
                {
                    url_slug: "administrator-resources-catalyst",
                    title: "Administrator Resources"
                },
                {
                    url_slug: "learner-resources-catalyst",
                    title: "Learner Resources"
                }
            ]
        }
        // {
        //   title: 'Team Edition',
        //   sublevels: [
        //     {
        //       url_slug: 'getting-started-team-edition',
        //       title: 'Getting Started',
        //     },
        //     {
        //       url_slug: 'administrator-tools-team-edition',
        //       title: 'Administrator Tools',
        //     },
        //     {
        //       url_slug: 'administrator-resources-team-edition',
        //       title: 'Administrator Resources',
        //     },
        //     {
        //       url_slug: 'learner-resources-team-edition',
        //       title: 'Learner Resources',
        //     },
        //   ],
        // },
    ]
};

export const deBusinessData = {
    navTitle: "Hub Navigieren",
    noDropDowns: [
        {
            title: "Bildung",
            url_slug: "bildungsressourcen"
        },
        {
            title: "Unternehmen",
            url_slug: "geschaeftsressourcen"
        }
    ],
    sections: []
};

export const deServicesData = {
    navTitle: "Hub Navigieren",
    noDropDowns: [],
    sections: [
        {
            title: "Produkte",
            sublevels: [
                {
                    title: "Catalyst",
                    url_slug: "catalyst"
                },
                {
                    title: "Rosetta Stone AEB",
                    url_slug: "rosetta-stone-aeb"
                },
                {
                    title: "Rosetta Stone V3",
                    url_slug: "v3"
                },
                {
                    title: "Advantage",
                    url_slug: "advantage"
                },
                {
                    title: "Foundaitons",
                    url_slug: "foundations"
                }
            ]
        },
        {
            title: "Type",
            sublevels: [
                {
                    title: "Videos: Catalyst",
                    url_slug: "catalyst-videos"
                }
                // {
                //   title: 'Course #4: Get Ready',
                //   url_slug: 'ent-get-ready',
                // },
                // {
                //   title: 'Course #5: Learn Your Resources',
                //   url_slug: 'ent-learn-your-resources',
                // },
                // {
                //   title: 'Course #6: Ready, Set, Learn!',
                //   url_slug: 'edu-ready-set-learn',
                // },
                // {
                //   title: 'Course #7: Progress Checkpoint',
                //   url_slug: 'ent-progress-checkpoint',
                // },
            ]
        }
    ]
};

export const ukBusinessData = {
    navTitle: "Navigate Hub",
    sections: [
        {
            title: "Sector",
            sublevels: [
                {
                    url_slug: "business",
                    title: "Business"
                },
                {
                    url_slug: "education",
                    title: "Education"
                }
            ]
        },
        {
            title: "Resource Type",
            sublevels: [
                {
                    url_slug: "videos-webinars",
                    title: "Videos and Webinars"
                },
                {
                    url_slug: "infographics",
                    title: "Infographics"
                },
                {
                    url_slug: "reports-ebooks",
                    title: "eBooks"
                },
                {
                    url_slug: "fact-sheets",
                    title: "Fact Sheets"
                }
            ]
        }
    ],
    noDropDowns: [
        {
            url_slug: "customer-stories",
            title: "Customer Stories"
        }
    ]
};

export const laBusinessData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};

export const esBusinessData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};

export const esK12Data = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};
export const esHEDData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};

export const frBusinessData = {
    navTitle: "",
    noDropDowns: [],
    sections: []
};

export const brBusinessData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};

export const itBusinessData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};

export const cnBusinessData = {
    navTitle: "",
    sections: [],
    noDropDowns: []
};
